/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * Constructor.
 * @class
 * @author eric.wittmann@gmail.com
 */
export class ResolverOptions {
    public static of(...options : ResolverOptionsType[]) : ResolverOptions {
        let rval : ResolverOptions = new ResolverOptions();
        if(options != null) {
            for(let index123=0; index123 < options.length; index123++) {
                let option = options[index123];
                {
                    rval.add(option);
                }
            }
        }
        return rval;
    }

    /*private*/ options : Array<ResolverOptionsType>;

    public constructor() {
        this.options = <any>([]);
    }

    public add(option : ResolverOptionsType) {
        /* add */((s, e) => { if(s.indexOf(e)==-1) { s.push(e); return true; } else { return false; } })(this.options, option);
    }

    public contains(option : ResolverOptionsType) : boolean {
        return /* contains */(this.options.indexOf(<any>(option)) >= 0);
    }
}
ResolverOptions["__class"] = "io.apicurio.datamodels.core.util.ResolverOptions";




import { ResolverOptionsType } from './ResolverOptionsType';

